<template>
  <div class="d-flex flex-column gap-4">
    <div>
      <v-card elevation="0" class="px-1">
        <v-tabs height="40px" class="transparent rounded-lg" v-model="filter">
          <v-tab tab-value="active">Ativo</v-tab>
          <v-tab tab-value="inactive">Encerrado</v-tab>
        </v-tabs>
      </v-card>
      <p v-if="!loading" class="text-caption mb-0 text-center">
        {{ parties[filter].length }} eventos
        {{ filter === "active" ? "ativos" : "encerrados" }}
      </p>
    </div>
    <party-card
      v-for="item in parties[filter].slice(0, renderLimit)"
      :key="item.id"
      class="px-3"
      :party="item"
      :loading="loading"
      :id="`party-${item.id}`"
    />

    <v-btn
      v-if="parties[filter].length > renderLimit"
      @click="renderLimit += 10"
      color="primary"
      large
      text
    >
      Ver mais
    </v-btn>
  </div>
</template>

<script>
import moment from "moment";
import PartyStatus from "@/utils/partyStatus";
import { mapGetters } from "vuex";
import PartyCard from "./PartyCard.vue";

export default {
  components: { PartyCard },
  data: () => ({
    filter: "active",
    renderLimit: 10,
  }),
  methods: {},
  computed: {
    ...mapGetters("auth", ["hasPermission", "config"]),
    ...mapGetters("organization", ["selectedOrganization"]),
  },
  watch: {
    filter(value) {
      this.renderLimit = 10;
      this.$emit("update:filter", value);
    },
  },
  props: {
    parties: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss"></style>
